<script lang="ts" setup>
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import { ref } from 'vue';
import axios from '../axios';
import FormField from './FormField.vue';

const props = defineProps<{
    url: string;
}>();

const emit = defineEmits<{
    added: [];
}>();

const email = ref('');
const processing = ref(false);
const errors = ref<Record<string, string[]>>({});

async function submit() {
    processing.value = true;
    errors.value = {};

    try {
        await axios.post(props.url, { email: email.value });

        email.value = '';
        emit('added');
    } catch (e: unknown) {
        const axiosErr = e as { response?: { data?: { errors?: Record<string, string[]> } } };
        errors.value = axiosErr?.response?.data?.errors ?? {};
    } finally {
        processing.value = false;
    }
}
</script>

<template>
    <div class="flex flex-col gap-4">
        <form
            class="flex flex-col"
            @submit.prevent="submit">
            <FormField
                label="Email"
                required>
                <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    placeholder="e.g. user@example.com"
                    required>
                <p
                    v-for="err in errors.email"
                    :key="err"
                    class="mt-1 text-sm text-rose-500">
                    {{ err }}
                </p>
            </FormField>

            <div class="flex justify-end pt-2">
                <button
                    type="submit"
                    class="btn btn-primary flex items-center gap-2"
                    :disabled="processing">
                    <ArrowPathIcon
                        v-if="processing"
                        class="h-4 w-4 animate-spin" />
                    Add Email
                </button>
            </div>
        </form>
    </div>
</template>
